import { render, staticRenderFns } from "./interviews-candidate.vue?vue&type=template&id=9b24787c"
import script from "./interviews-candidate.vue?vue&type=script&lang=js"
export * from "./interviews-candidate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports